import TextField from "@mui/material/TextField";
import { ui } from "./tokens";

export default function FormTextField(props) {
  const { InputLabelProps, ...rest } = props;
  return (
    <TextField
      fullWidth
      variant="outlined"
      size="medium"
      InputLabelProps={{
        ...(InputLabelProps || {}),
        sx: { ...ui.label, ...(InputLabelProps?.sx || {}) },
      }}
      {...rest}
    />
  );
}
